import { Outlet } from "react-router-dom"
import MainError from "../pages/MainError"

export default function PrivateRoleRoutes({ role, rolesNeeded, establishmentType, establishmentNeeded }) {
  let authorized =
    rolesNeeded.includes(role.id) &&
    (establishmentNeeded === undefined || (establishmentType && establishmentNeeded.includes(establishmentType.id)))
  return authorized ? <Outlet /> : <MainError />
}
